import { render, staticRenderFns } from "./buyerStat.vue?vue&type=template&id=0e6b8602&"
import script from "./buyerStat.vue?vue&type=script&lang=js&"
export * from "./buyerStat.vue?vue&type=script&lang=js&"
import style0 from "./buyerStat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports